'use strict';

var R = require('ramda');

var rejectEmptyStrings = R.filter(R.test(/\S/));

module.exports = rejectEmptyStrings;


//////////////////
// WEBPACK FOOTER
// ./~/lokum/lib/rejectEmptyStrings.js
// module id = 354
// module chunks = 0